import Vue from 'vue';
import PortalVue from 'portal-vue';
import App from './App.vue';
import 'bootstrap';
import './scss/app.scss';
import { BootstrapVue, BootstrapVueIcons } from 'bootstrap-vue';

import router from './router';
import store from './store';

import VueAnalytics from 'vue-analytics';
import LazyLoadDirective from './directives/LazyLoadDirective';

Vue.config.productionTip = false;

Vue.directive('lazyload', LazyLoadDirective);

Vue.use(VueAnalytics, {
  id: process.env.VUE_APP__GOOGLE_ANALYTICS_CODE,
  checkDuplicatedScript: true,
  router,
  set: [{ field: 'anonymizeIp', value: true }],
});
Vue.use(PortalVue);
Vue.use(BootstrapVue);
Vue.use(BootstrapVueIcons);

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app');
